<div class="centered-main-content">
    <h1>Página no encontrada</h1>
    <button type="button" mat-raised-button color="primary" (click)="backClicked()">
        REGRESAR
    </button>
</div>